module.exports = __webpack_public_path__ + "7fc0b5f43eb66a16472007db0af034cd.pdf";